export const getAbsoluteSrc = (relativeSrc) => {
	// Already a full URL — return as-is
	if (relativeSrc.startsWith('http://') || relativeSrc.startsWith('https://')) {
		return relativeSrc;
	}
	return new URL(relativeSrc, window.location.origin).href;
};
